var _defs, _path, _rect, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWiFi1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.94 36.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .wifi_1__cls-1 {\n        stroke: currentColor;\n      }\n\n      .wifi_1__cls-1, .wifi_1__cls-2 {\n        fill: none;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n\n      .wifi_1__cls-2 {\n        stroke: #B1B1B1;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wifi_1__cls-2",
    d: "M35.65,12.72c-2.25-2.28-4.93-4.1-7.88-5.34-5.95-2.49-12.64-2.49-18.59,0-2.95,1.24-5.63,3.06-7.88,5.34M7.02,18.53c3.02-3.07,7.14-4.8,11.45-4.81,4.31,0,8.43,1.74,11.45,4.81M24.2,24.33c-3.09-3.16-8.16-3.22-11.32-.13-.04.04-.09.09-.13.13"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "wifi_1__cls-1",
    x: 18.45,
    y: 30.03,
    width: 0.03,
    height: 0.03
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "wifi_1__cls-1",
    cx: 18.45,
    cy: 30.03,
    r: 1.29
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiFi1);
export default __webpack_public_path__ + "static/media/WiFi_1.2322fd7b8ade72e64fb35c7379e1d37e.svg";
export { ForwardRef as ReactComponent };